import React, { useState, useEffect } from "react";
import { useParams } from 'react-router-dom';
import axios from 'axios'; // Import axios for API call
import BottomNav from "../../component/BottomNav";
import { API_URL } from "../../common/constant";
import Appartment_rent from "../../component/Appartment_rent_in_society/Appartment_rent_in_society";

const ProjectDetails = () => {
    const { id } = useParams();
    const [projectDetails, setProjectDetails] = useState(null); // State to hold the fetched project details
    const [selectedImage, setSelectedImage] = useState('');
    const [images, setImages] = useState([]);

    // Fetch project details by ID from the backend
    useEffect(() => {
        const fetchProjectDetails = async () => {
            try {
                const response = await axios.get(`${API_URL}/api/society/get-society/${id}`);
                if (response.data.society) {
                    setProjectDetails(response.data.society);
                    setImages([response.data.society.mainImage, ...response.data.society.otherImages.map(img => img.img_name)]);
                    setSelectedImage(response.data.society.mainImage);
                }
            } catch (error) {
                console.error("Error fetching project details", error);
            }
        };

        fetchProjectDetails();
        window.scrollTo(0, 0); // Scroll to top when component loads
    }, [id]);

    if (!projectDetails) {
        return <div>Loading...</div>; // Loading state until data is fetched
    }

    console.log('society detail==>', projectDetails)

    return (
        <div className="bg-gray-50 min-h-screen p-4 md:p-6">
            <div className=" rounded-lg p-4 ">
                <div className="flex flex-col lg:flex-row">
                    {/* Left Side: Project Overview */}
                    <div className="lg:w-1/2">
                        {/* Image Review Section */}
                        <div>
                            {/* Main Image Preview */}
                            <img
                                src={`${API_URL}/uploads/societies/${id}/${selectedImage}`}
                                alt="Project"
                                className="w-full h-64 md:h-96 rounded-lg object-cover"
                            />
                            <div className="flex space-x-4 mt-4 overflow-x-auto">
                                {images.map((image, index) => (
                                    <img
                                        key={index}
                                        src={`${API_URL}/uploads/societies/${id}/${image}`}
                                        alt={`Thumbnail ${index + 1}`}
                                        className={`w-16 h-16 md:w-20 md:h-20 object-cover rounded-lg cursor-pointer ${selectedImage === image
                                            ? "border-4 border-[#54BD95]"
                                            : "border"
                                            }`}
                                        onClick={() => setSelectedImage(image)}
                                    />
                                ))}
                            </div>
                        </div>

                        {/* Project Overview */}
                        <div className="mt-4">
                            <h1 className="text-xl md:text-2xl font-bold text-gray-800">
                                {projectDetails.name}
                            </h1>
                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-4">
                                <div>
                                    <p className="text-sm text-gray-500">Total Project Area</p>
                                    <p className="text-lg font-semibold">{projectDetails.area}</p>
                                </div>
                                {/* <div>
                                    <p className="text-sm text-gray-500">Total Units</p>
                                    <p className="text-lg font-semibold">
                                        {(
                                            (projectDetails.one_bhk_unit ? parseInt(projectDetails.one_bhk_unit) : 0) +
                                            (projectDetails.two_bhk_unit ? parseInt(projectDetails.two_bhk_unit) : 0) +
                                            (projectDetails.three_bhk_unit ? parseInt(projectDetails.three_bhk_unit) : 0) +
                                            (projectDetails.four_bhk_unit ? parseInt(projectDetails.four_bhk_unit) : 0)
                                        )} Units
                                    </p>

                                </div> */}
                                {/* <div>
                                    <p className="text-sm text-gray-500">BHK</p>
                                    <p className="text-lg font-semibold">
                                        {
                                            (parseInt(projectDetails.one_bhk_unit) > 0 ? '1 BHK, ' : '') +
                                            (parseInt(projectDetails.two_bhk_unit) > 0 ? '2 BHK, ' : '') +
                                            (parseInt(projectDetails.three_bhk_unit) > 0 ? '3 BHK, ' : '') +
                                            (parseInt(projectDetails.four_bhk_unit) > 0 ? '4 BHK' : '')
                                        }
                                    </p>
                                </div> */}
                                <div>
                                    <p className="text-sm text-gray-500">Price Range</p>
                                    <p className="text-lg font-semibold">{projectDetails.range}</p>
                                </div>
                                <div>
                                    <p className="text-sm text-gray-500">Property Type</p>
                                    <p className="text-lg font-semibold">Apartment</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Right Side: Unit Configuration */}
                    <div className="lg:w-1/2 lg:pl-6 mt-6 lg:mt-0">
                        <h2 className="text-xl font-semibold text-gray-800 mb-4">
                            Unit Configuration
                        </h2>
                        <table className="w-full text-left border-collapse">
                            <thead>
                                <tr>
                                    <th className="border-b p-2 text-gray-600">Unit Type</th>
                                    <th className="border-b p-2 text-gray-600">
                                        Super Built-Up Area
                                    </th>
                                    <th className="border-b p-2 text-gray-600">Price</th>
                                </tr>
                            </thead>
                            <tbody>
                                {[{ type: "1 BHK", area: projectDetails.one_bhk_area, price: projectDetails.one_bhk_unit },
                                { type: "2 BHK", area: projectDetails.two_bhk_area, price: projectDetails.two_bhk_unit },
                                { type: "3 BHK", area: projectDetails.three_bhk_area, price: projectDetails.three_bhk_unit },
                                ]
                                    .map((unit, index) => (
                                        <tr key={index} className="hover:bg-gray-50">
                                            <td className="border-b p-2">{unit.type}</td>
                                            <td className="border-b p-2">{unit.area}</td>
                                            <td className="border-b p-2">{unit.price}</td>
                                        </tr>
                                    ))}
                            </tbody>
                        </table>

                        {/* Facilities */}
                        <div className="mt-8">
                            <h2 className="text-xl font-semibold text-gray-800 mb-4">
                                Facilities
                            </h2>
                            <div className="grid grid-cols-3 gap-6 text-gray-700">
                                {/* Display each facility as a separate grid item */}
                                {projectDetails.facilities.map((facility, index) => (
                                    <div key={index} className="space-y-2">
                                        <p className="text-sm sm:text-base">{'* ' + facility}</p>
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div className="mt-8">
                            <h2 className="text-xl font-semibold text-gray-800 mb-4">
                                Description
                            </h2>
                            <div className=" text-gray-700">
                                {/* Display each facility as a separate grid item */}
                                <div className="space-y-2">
                                    <p className="text-sm sm:text-base">{projectDetails.desc}</p>
                                </div>

                            </div>
                        </div>





                    </div>
                </div>
            
              
               

                {/* Location Section */}
                <div className="bg-white shadow-md rounded-lg p-6 mt-6">
                    <h2 className="text-xl font-semibold text-gray-800 mb-4">Location</h2>
                    <div className="relative">
                        <iframe
                            src={projectDetails.mapLocation}
                            width="100%"
                            height="350"
                            style={{ border: 0 }}
                            allowFullScreen=""
                            loading="lazy"
                            title="Location Map"
                            className="rounded-lg w-full cursor-pointer"
                        />
                    </div>
                </div>
            </div>
            <BottomNav />
        </div>
    );

};

export default ProjectDetails;
